import { AppContextState } from './app-context.model';

export type { AppContextState } from './app-context.model';

export const initialAppContextState: AppContextState = {
  persistedAppContext: {
    selectedCountry: null,
    originalUser: '',
    originalRole: '',
    isSuperAdmin: 'N',
  },
  allCountries: [],
};
